<template>
    <div class="s-nice-text">
        <div class="o-layout  o-layout--right">
            <div v-for="topicCategory in topicCategories" class="o-layout--right">
                <div class="o-layout__item  u-4/12  u-12/12@sm  o-layout--right">
                    <img v-if="topicCategory.image" class="u-12/12  u-margin-bottom"
                         :src="$root.pUrl + topicCategory.image"
                         alt="">
                </div>
                <div class="o-layout__item  u-8/12  u-12/12@sm">
                    <h2 class="u-margin-bottom-large">{{ topicCategory.name }}</h2>
                    <div v-if="topicCategory.description"
                         v-html="topicCategory.description.replace(/\n/g, '<br>')"></div>
                    <ul>
                        <li v-for="topic in topicCategory.topics">

                            <topic-title :topic="topic" :isLink="!!topic.introLong"/>

                            <p class="s-nice-text__small  c-minus-intent-large  u-text-keep-words"
                               v-if="topic.profiles.length" v-for="profile of topic.profiles">
                                <span class="u-text-bold">{{ profile.name }}</span>
                                {{ profile.introShort }}
                            </p>
                        </li>
                    </ul>
                </div>
                <div class="o-layout__item  u-10/12  u-12/12@md">
                    <div class="c-separator  c-separator--nice  u-margin-bottom  u-padding-top"></div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    export default {
        name: "Topics",
        props: ["topicCategories", 'marxism'],
        methods: {},
        mounted() {

            let pageTitle = '전체 주제';
            document.querySelector('title').innerText = `${pageTitle} | ${marxism.title} - 마르크스주의 포럼`;

            if (window.gtag) {
                if (window.gtag) {
                    // for google analytics page tracking
                    window.gtag('config', 'UA-2193909-1', {
                        'page_title': `${pageTitle} | ${this.marxism.title} - 마르크스주의 포럼`,
                        'page_path': (new URL(location.href)).pathname
                    });
                }
            }
        }
    }
</script>

<style scoped>

</style>
